  /**
   * Helper utilities for authentication
   */

  /**
   * Get the authentication token from localStorage
   * @returns {string|null} The authentication token or null if not found
   */
  export const getToken = () => {
    return localStorage.getItem("accessToken");
  };

  /**
   * Check if the user is authenticated
   * @returns {boolean} True if the user is authenticated, false otherwise
   */
  export const isAuthenticated = () => {
    return !!getToken();
  };

  /**
   * Get the current user from localStorage
   * @returns {Object|null} The current user or null if not found
   */
  export const getCurrentUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        console.error("Error parsing user data:", error);
        return null;
      }
    }
    return null;
  };

  /**
   * Log out the user by removing authentication data from localStorage
   * and redirecting to the sign-in page
   */
  export const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    // Redirect to login page
    window.location.href = "/signin";
  };

  /**
   * Store authentication data in localStorage
   * @param {Object} authData - The authentication data to store
   */
  export const storeAuthData = (authData) => {
    if (authData?.access_token) {
      localStorage.setItem("accessToken", authData.access_token);
    }
    
    if (authData?.user) {
      localStorage.setItem("user", JSON.stringify(authData.user));
    }
  };

  /**
   * Get authentication header for API requests
   * @returns {Object} 
   */
  export const getAuthHeader = () => {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  };